import { render, staticRenderFns } from "./BoxSelectWidget.vue?vue&type=template&id=1eae90f6&scoped=true&"
import script from "./BoxSelectWidget.vue?vue&type=script&lang=js&"
export * from "./BoxSelectWidget.vue?vue&type=script&lang=js&"
import style0 from "./BoxSelectWidget.vue?vue&type=style&index=0&id=1eae90f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eae90f6",
  null
  
)

export default component.exports